module.exports = __webpack_public_path__ + "static/img/wechat-code.943cce84.png";